import React, { useContext, useEffect, useState, useCallback } from "react";
import { withRouter } from "react-router-dom";
import { SHOPIFY_API_KEY, SHOPIFY_EMBEDDED_FORCE_REDIRECT } from "aws-exports";
import { Provider } from "@shopify/app-bridge-react";
import createApp from "@shopify/app-bridge";
import { Redirect, History, Toast } from "@shopify/app-bridge/actions";
import { useRoutePropagation } from "@shopify/react-shopify-app-route-propagator";
import useReactRouter from "use-react-router";
import NotifyContext from "context/NotifyContext";
import ShopContext from "context/ShopContext";
import { ErrorScreen } from "screens";
import { EmbeddedProvider } from "context/EmbeddedContext";
import UserContext from "context/UserContext";
import { ENGINE_WARNING_ICON } from "lib/globals";
import ChargeApproval from "./chargeApproval";
import WelcomeModal from "./welcomeModal";
import { setupModalAutoSizing } from "@shopify/app-bridge-utils";

const Embedded = ({ children, location, newPlanRedirect }) => {
  const { history } = useReactRouter();
  const user = useContext(UserContext);
  const shopContext = useContext(ShopContext);
  const {
    state: {
      settings,
      settingsSaved,
      chargeConfirmationUrl,
      redirectToChargeApproval,
      id,
      installedAt
      // show_recharge_alert
    },
    setItem
  } = shopContext;
  const { createNotification, deleteNotification } = useContext(NotifyContext);
  const queryString = window.location.search;
  const params = new URLSearchParams(queryString);
  const config = {
    apiKey: SHOPIFY_API_KEY,
    shopOrigin: user.attributes.website,
    forceRedirect: SHOPIFY_EMBEDDED_FORCE_REDIRECT,
    host: params.get("host") || btoa(user.attributes.website)
  };
  const app = createApp(config);
  setupModalAutoSizing(app);
  const AppBridgeHistory = History.create(app);
  const AppBridgeRedirect = Redirect.create(app);
  const AppBridgeToast = toastOptions => {
    const toast = Toast.create(app, toastOptions)
    return {
      open () {
        toast.dispatch(Toast.Action.SHOW)
      }
    }
  };
  useRoutePropagation(app, location);
  useEffect(() => {
    if (window.$crisp) {
      window.$crisp.push(["set", "session:data", ["store", id]]);
      window.$crisp.push(["set", "session:data", ["App", "Monster UPSELLS"]]);
    }
  }, [settings]);
  useEffect(() => {
    if (params.get("source") === 'charge-accepted') {
      window.fbq('track', 'TrialStarted')
      AppBridgeRedirect.dispatch(Redirect.Action.APP, '')
    }
  }, [params])
  // src={ `${window.location.origin}/${getPlansModal(new Date(installedAt).getTime())}?chargeConfirmationUrl=${chargeConfirmationUrl}`}
  return (
    <>
      <EmbeddedProvider value={{ app, AppBridgeRedirect, AppBridgeHistory, AppBridgeToast }}>
        <Provider config={config}>
          {!!(redirectToChargeApproval && window.location.pathname !== "/affiliation") && <ChargeApproval />}
          {!redirectToChargeApproval && <WelcomeModal />}
          <ErrorScreen>{children}</ErrorScreen>
        </Provider>
      </EmbeddedProvider>
    </>
  );
};

export default withRouter(Embedded);
